module.exports = __webpack_public_path__ + "img/bg-img-2.7facde13.png";